import React from 'react';

export default function PixelGlassesSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      {/* Left lens - blocky pixel art */}
      <rect x="3" y="16" width="14" height="10" fill="#1A1A1A" />
      {/* Right lens */}
      <rect x="23" y="16" width="14" height="10" fill="#1A1A1A" />
      {/* Bridge */}
      <rect x="17" y="18" width="6" height="4" fill="#1A1A1A" />
      {/* Left temple */}
      <rect x="1" y="16" width="4" height="3" fill="#1A1A1A" />
      {/* Right temple */}
      <rect x="35" y="16" width="4" height="3" fill="#1A1A1A" />
      {/* Pixel detail on left lens */}
      <rect x="5" y="18" width="4" height="4" fill="#333333" />
      <rect x="11" y="18" width="4" height="4" fill="#333333" />
      {/* Pixel detail on right lens */}
      <rect x="25" y="18" width="4" height="4" fill="#333333" />
      <rect x="31" y="18" width="4" height="4" fill="#333333" />
      {/* Highlight pixels */}
      <rect x="5" y="18" width="2" height="2" fill="#555555" />
      <rect x="25" y="18" width="2" height="2" fill="#555555" />
    </svg>
  );
}
